import React from 'react'
import PrivateRoute from '../auth/PrivateRoute'
import { withRouter } from 'react-router-dom'
import UserTable from './UserTable'
import UserFormPage from './UserFormPage'
import { findAccessLevel } from '../../modules/accessRoute'

export class UserPage extends React.Component {
  handleSubmit = () => {
    this.props.history.push(`/user`)
  }

  table = () => <UserTable path="/user" />

  formPage = ({
    match: {
      params: { id },
    },
  }) => <UserFormPage id={id} onSubmit={this.handleSubmit} />

  render() {
    return (
      <div>
        <PrivateRoute
          exact
          path="/user"
          component={this.table}
          ifAnyGranted={findAccessLevel('/user')}
        />

        <PrivateRoute
          path="/user/new"
          component={this.formPage}
          ifAnyGranted={findAccessLevel('/user')}
        />

        <PrivateRoute
          path="/user/edit/:id"
          component={this.formPage}
          ifAnyGranted={findAccessLevel('/user')}
        />
      </div>
    )
  }
}
export default withRouter(UserPage)
